import { render, staticRenderFns } from "./CoursewareActivities.vue?vue&type=template&id=3d10d687&"
import script from "./CoursewareActivities.vue?vue&type=script&lang=js&"
export * from "./CoursewareActivities.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports